import { Typography } from '@mui/material';

import { IProjectWithBlockchains } from 'domains/projects/types';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { ProjectNames } from '../ProjectNames';
import { projectsListTranslation } from './translation';
import { useProjectListStyles } from './useProjectListStyles';

export interface IProjectsListProps {
  projects: IProjectWithBlockchains[];
}

const MAX_VISIBLE_PROJECTS = 2;

export const ProjectsList = ({ projects }: IProjectsListProps) => {
  const { classes } = useProjectListStyles();
  const { keys, t } = useTranslation(projectsListTranslation);

  const notAddedLabel = (
    <Typography
      className={classes.notAddedText}
      color="textSecondary"
      variant="body3"
    >
      {t(keys.notAdded)}
    </Typography>
  );

  if (!projects.length) {
    return notAddedLabel;
  }

  if (projects.length <= MAX_VISIBLE_PROJECTS) {
    return <ProjectNames projects={projects} />;
  }

  if (projects.length > MAX_VISIBLE_PROJECTS) {
    const visibleProjects = projects.slice(0, MAX_VISIBLE_PROJECTS);
    const hiddenProjectsCount = projects.length - MAX_VISIBLE_PROJECTS;

    return (
      <>
        <ProjectNames projects={visibleProjects} />
        <Typography color="textSecondary" variant="body3">
          +{hiddenProjectsCount}
        </Typography>
      </>
    );
  }

  return notAddedLabel;
};
